import _ from 'lodash'
import {
  IP_OBJECT,
  IP_QUESTION_CODE,
  IP_RESPONSE_TYPE,
  IP_API_VALUE_TYPE,
  IP_API_VALUE_KEY,
  AREA,
  CITY,
  COUNTY,
  NOT_SPECIFIED,
  PLACE,
  COUNTY_PROP_NAME,
  STATE_PROP_NAME,
  CITY_PROP_NAME,
  ZIP_PROP_NAME,
  LOCATION_TYPE,
  YES_OCCUPIED,
  NOT_OCCUPIED,
  BANK_OWNED,
  FORECLOSURE,
  PRIVATE_SELLER,
  ALL,
  BOTH,
  NUDGE_CONSTANTS,
} from './constants'

/**
 * Transform the Onboarding questions to the form expected values
 */
export const storeToForm = set => {
  const formObject = {}
  switch (set.code) {
    case IP_QUESTION_CODE.INV_ONBOARDING_LOOKING_TO_BUY: {
      formObject[set.code] = set.answer.value
      return formObject
    }
    default: {
      const answer =
        set.answer.value &&
        set.answer.value[0][IP_API_VALUE_KEY[set.answer.type]]
      if (answer === NOT_SPECIFIED) {
        formObject[set.code] = ''
      } else {
        formObject[set.code] = answer
      }
      return formObject
    }
  }
}

/**
 * Transform the form expected values to Onboarding questions
 */
export const formToStore = (set, values) => {
  switch (set.code) {
    case IP_QUESTION_CODE.INV_ONBOARDING_LOOKING_TO_BUY:
      return {
        ...set,
        answer: {
          ...set.answer,
          value: values[set.code],
        },
      }
    default:
      return {
        ...set,
        answer: {
          ...set.answer,
          value: [{ [IP_API_VALUE_KEY[set.answer.type]]: values[set.code] }],
        },
      }
  }
}

export const assetType = value => {
  if (!value) return {}
  switch (value) {
    case BANK_OWNED: {
      return { usecode_product_type: 'resi_bo_v2,resi_new_foreclosed' }
    }
    case FORECLOSURE: {
      return { usecode_product_type: 'resi_ft' }
    }
    case PRIVATE_SELLER: {
      return { usecode_product_type: 'resi_ps' }
    }
    case ALL:
    case BOTH: {
      return {}
    }
    default:
      return {}
  }
}

export const occupancyStatus = value => {
  if (!value) return {}
  switch (value) {
    case NOT_OCCUPIED:
      return { occ_status: 'vacant' }
    case YES_OCCUPIED:
    default:
      return {}
  }
}

/**
 * Get the API expected object from a given set
 */
export const apiValue = set => ({
  question_code: set.code,
  response_type_code: IP_RESPONSE_TYPE[set.answer.type],
  [IP_API_VALUE_TYPE[set.answer.type]]: set.answer.value,
})

/**
 * Instantiate an Onboarding object from a given API response
 */
export const parseQuestions = (data = []) => {
  const parsedQuestions = IP_OBJECT()
  data.forEach(entry => {
    const question = parsedQuestions[entry.question_code]
    parsedQuestions[entry.question_code] = {
      ...question,
      answer: {
        ...question.answer,
        value: entry[IP_API_VALUE_TYPE[question.answer.type]].map(answer => {
          const valueKey = IP_API_VALUE_KEY[question.answer.type]
          return { [valueKey]: answer[valueKey] }
        }),
      },
    }
  })
  return parsedQuestions
}

export const generateNewLocation = suggestion => {
  switch (suggestion.type) {
    case 'zip':
      return {
        place: {
          postal_code: suggestion.filters.property_zip,
          location_type_code: AREA,
        },
      }
    case 'city':
    case 'currentLocation':
      return {
        place: {
          country_primary_subdivision: suggestion.filters.property_state,
          municipality: suggestion.filters.property_city,
          location_type_code: CITY,
        },
      }
    case 'county':
    default:
      return {
        place: {
          country_primary_subdivision: suggestion.filters.property_state,
          country_secondary_subdivision: suggestion.label
            .split(',')?.[0]
            ?.trim(),
          location_type_code: COUNTY,
        },
      }
  }
}

export const updateValueBasedOnSuggestion = (value, suggestion) => {
  const newValue = [...value]
  const newLocation = generateNewLocation(suggestion)

  if (!_.find(newValue, newLocation) && newValue.length < 5) {
    newValue.push(newLocation)
  }
  return newValue
}

export const placeToLabel = val => {
  let county = val[PLACE][COUNTY_PROP_NAME]
  const state = val[PLACE][STATE_PROP_NAME]
  const city = val[PLACE][CITY_PROP_NAME]
  const zip = val[PLACE][ZIP_PROP_NAME]
  const locationType = val[PLACE][LOCATION_TYPE]

  switch (locationType) {
    case AREA:
      if (state === 'PR') deleteUnusedField(val[PLACE], ZIP_PROP_NAME)
      return zip
    case CITY:
      return _.join([city, state], ', ')
    default:
      if (state === 'PR') {
        county = county.concat(' County')
      }
      return _.join([county, state], ', ')
  }
}

export const deleteUnusedField = (value, type) => {
  for (const field in value) {
    if (field === LOCATION_TYPE) {
      continue
    } else if (field !== type) {
      delete value[field]
    }
  }
}

export const placeToPreference = ({ place }) => {
  const conversionMap = {
    municipality: 'property_city',
    country_secondary_subdivision: 'property_county',
    postal_code: 'property_zip',
    country_primary_subdivision: 'property_state',
  }
  const SSPreference = {}
  for (const key in conversionMap) {
    let value = place[key]
    if (!value) continue
    // This clause removes the County from "Orange County"
    if (key === 'country_secondary_subdivision' && value.endsWith('County'))
      value = value.replace(' County', '')
    SSPreference[conversionMap[key]] = value
  }
  return SSPreference
}

export const parseRiddlerPreferences = userPreferences => {
  let haveAllBuyerPreferences = true
  NUDGE_CONSTANTS().REQUIRED_QUESTION_CODES.forEach(code => {
    const questionAnswered = _.find(
      userPreferences,
      o => o.question_code === code
    )
    if (!questionAnswered) haveAllBuyerPreferences = false
  })
  return haveAllBuyerPreferences
}
